import 'survey-core/survey-core.css';
import 'survey-creator-core/survey-creator-core.css';
import { useState, useImperativeHandle, forwardRef } from 'react';
import { ICreatorOptions } from 'survey-creator-core';
import { SurveyCreator as SjsSurveyCreator, SurveyCreatorComponent } from 'survey-creator-react';

import { extendSurveyModel, registerComponents } from '../shared/customiser';

registerComponents();

const defaultCreatorOptions: ICreatorOptions = {
  autoSaveEnabled: true,
  collapseOnDrag: true,
};

interface ISurveyCreatorRef {
  creator: SjsSurveyCreator | undefined;
}

const SurveyCreator = forwardRef<
  ISurveyCreatorRef,
  { readonly initialJson?: object; readonly options?: ICreatorOptions }
>((props, ref) => {
  const [creator, setCreator] = useState<SjsSurveyCreator>();

  useImperativeHandle(ref, () => ({
    creator,
  }));

  if (!creator) {
    const newCreator = new SjsSurveyCreator(props.options ?? defaultCreatorOptions);
    newCreator.JSON = props.initialJson ?? {};

    extendSurveyModel(newCreator.survey);
    newCreator.onSurveyInstanceCreated.add((_, options) => {
      if (options.area === 'preview-tab') {
        const { survey } = options;
        extendSurveyModel(survey);
      }
    });

    setCreator(newCreator);
  }

  return (
    <div style={{ height: '100vh', width: '100%' }}>{creator && <SurveyCreatorComponent creator={creator} />}</div>
  );
});

SurveyCreator.displayName = 'SurveyCreator';

export type { ISurveyCreatorRef };
export { SurveyCreator };
